import React from "react";
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';

export default function PresentationTitreST({titre}) {
    return (
        <h1 className="center red fs40 initial mt20">{titre}</h1>
    )
}